module.exports = __webpack_public_path__ + "static/media/img_system4.359f6a35.png";